import hasAddresses from './utilities/hasAddresses';
import hasPhones from './utilities/hasPhones';
import hasFullName from './utilities/hasFullName';
import hasRoles from './utilities/hasRoles';
import hasTags from './utilities/hasTags';

const user = (userJson) => {
  const properties = {
    ...userJson.attributes,
    guid: userJson.guid,
    active: userJson.active,
    hasTempPass: userJson.hasTempPass,
    user_apps: userJson.user_apps
  };
  return Object.assign(
    properties,
    hasAddresses(userJson.attributes.addresses),
    hasFullName(userJson.attributes),
    hasPhones(userJson.attributes.phones),
    hasRoles(userJson.attributes.roles),
    hasTags(userJson.attributes.tags),
  );
};

export default user;
